export default __webpack_public_path__ + "eabaefe9b8405eaaf8dfe3833348881d.svg";